var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text text-primary text-center"},[_c('i',{class:{ 'el-icon-icon-checkbox-checked': _vm.checked, 'el-icon-icon-checkbox-unchecked': !_vm.checked }})])
}
var staticRenderFns = []

export { render, staticRenderFns }